import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { WindowService } from 'src/app/core/services/window/window.service';

@Component({
    selector: 'app-session-expired-dialog',
    templateUrl: './session-expired-dialog.component.html',
    styleUrls: ['./session-expired-dialog.component.scss'],
    standalone: false
})
export class SessionExpiredDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<SessionExpiredDialogComponent>,
    private windowService: WindowService
  ) {}

  goToLogin(): void {
    this.dialogRef.close();
    sessionStorage.clear();
    this.windowService.toOrigin();
  }
}
